//@import dependencies
import React from 'react'
import { useTranslation } from 'react-i18next'
//@end

//@import components
import IconsComponent from 'app_components/commons/icons'
//@end

// @import hooks
// @end

// @INFO Import types
// @end

// @INFO Import services
// @end

// @INFO Import Styles
import './../emptyStateCommon.scss'

// @ADD Component types
interface IEmptyStateCommonLayoutProps {
  showAddMessage?: boolean
  customMessage?: string | null
}

const EmptyStateCommonLayout: React.FC<IEmptyStateCommonLayoutProps> = (props) => {

  const { t } = useTranslation()

  return(
    <div className='empty-state-component'>
      <div className='bars'>
        <IconsComponent svg="GraphicBar" width='24px' height='24px' />
      </div>
      {props.customMessage ? (
        <div className='message'>{props.customMessage}</div>
      ) : (
        <div className='message'>
          {t('components.emptyState.no_information_to_display')}
          <br />
          {props.showAddMessage && t('components.emptyState.click_on_add_to_load_the_information')}
        </div>
      )}
    </div>
  )
}

export default EmptyStateCommonLayout
